import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/features/auth/services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  userDetails;

  constructor(private router: Router,
    private authService: AuthService) { }

  ngOnInit() {
    // this.userDetails =  this.authService.getLoggedInUser()
    this.userDetails = JSON.parse(localStorage.getItem('userProfile'));
    console.log('userdetails',this.userDetails);
  }

  onLogout() {

    // localStorage.removeItem('userrole');
    // localStorage.removeItem('crewId');
    // localStorage.removeItem('userProfile');
    this.authService.logout().subscribe(res => console.log('logout successfully'),
    err => console.log('error while logout'))
    localStorage.clear();
    this.router.navigate(['/auth/login']);
  }

  onchangePassword() {
	let userToken = localStorage.getItem('token');
    this.router.navigate(['/auth/changepassword']);
  }
}
